import React from 'react';
import Icon from '../../Icon';
import '../styles/_step.scss';

export default function Seperator({ seperatorColor = 'nevada' }) {
  return (
    <div className="step--separator">
      <Icon className="step--separator__icon" name="dot" size={4} color={seperatorColor} />
      <Icon className="step--separator__icon" name="dot" size={4} color={seperatorColor} />
      <Icon className="step--separator__icon" name="dot" size={4} color={seperatorColor} />
    </div>);

}